import { isNilOrEmpty, not } from '@yoop/util';

/**
 * Joins the string with the given separator, but after removing all nulls.
 * @param strings
 * @param separator
 */
export const joinNonNull = (strings: string[], separator = ' '): string | '' => {
  return strings.filter(not(isNilOrEmpty)).join(separator);
};
